import {
    CommoditiesState,
    FetchCommoditiesActionTypes,
    FETCH_COMMODITIES_STARTED,
    FETCH_COMMODITIES_SUCCESS,
    FETCH_COMMODITIES_ERROR,

    POST_COMMODITY_STARTED,
    POST_COMMODITY_SUCCESS,
    POST_COMMODITY_ERROR,

    PUT_COMMODITY_STARTED,
    PUT_COMMODITY_SUCCESS,
    PUT_COMMODITY_ERROR,

    DELETE_COMMODITY_STARTED,
    DELETE_COMMODITY_SUCCESS,
    DELETE_COMMODITY_ERROR
  } from "./types";

const initialState: CommoditiesState = {
    items: [],
    isFetching:false,
    error: {},
};

export function commoditiesReducer(
    state=initialState,
    action: FetchCommoditiesActionTypes
):CommoditiesState {

    switch(action.type){
        case POST_COMMODITY_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case POST_COMMODITY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: []
            })
        case POST_COMMODITY_ERROR:
            return Object.assign({}, state, {
                isFetching: false
            })
        case PUT_COMMODITY_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case PUT_COMMODITY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: []
            })
        case PUT_COMMODITY_ERROR:
            return Object.assign({}, state, {
                isFetching: false
            })
        case DELETE_COMMODITY_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case DELETE_COMMODITY_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                items: []
            })
        case DELETE_COMMODITY_ERROR:
            return Object.assign({}, state, {
                isFetching: false
            })
        case FETCH_COMMODITIES_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case FETCH_COMMODITIES_SUCCESS:
            return Object.assign({}, state, {
                items: action.commodities,
                isFetching: false
            })
        case FETCH_COMMODITIES_ERROR:
            return Object.assign({}, state, {
                error: action.error,
                isFetching: false
            })
        default:
            return state;
    }
} 